import { useQuery } from '@tanstack/react-query';
import { API } from '@/services/api.service';
import { QUERY_KEY } from '@/shared/constants';

export function useCompaniesDropdown({ queryParams, enabled = true }) {
  return useQuery({
    queryKey: [QUERY_KEY.companiesDropdown, queryParams],
    queryFn: async () => {
      return await API.companies.retrieveDropdownAllCompanies(queryParams);
    },
    select: (data) => {
      const companies = data?.items || [];
      const isSingle = data?.isSingleCompany;

      return {
        isSingle,
        options: companies?.map((company) => ({
          value: company._id,
          label: company.name,
        })),
      };
    },
    retry: false,
    refetchOnWindowFocus: false,
    enabled: enabled,
    staleTime: 1000 * 60, // 1 minute
  });
}
